const config = {
  router: {
    basename: '/member'
  },
  auth0: {
    domain: 'pulser.auth0.com',
    clientID: '7CiAvfIIGh0KzDk6DMZLEzF4UL9x0uOk',
    responseType: 'token id_token'
  },
  firebase: {
    apiKey: "AIzaSyAwSA8wmllm-Y716yKVEvDZMn201cJTmVs",
    authDomain: "pulser-e265e.firebaseapp.com",
    databaseURL: "https://pulser-e265e.firebaseio.com",
    projectId: "pulser-e265e",
    storageBucket: "pulser-e265e.appspot.com",
    messagingSenderId: "570931850987"
  },
  search: {
    host: 'https://pulser.herokuapp.com'
  },
  filestack: {
    apiKey: 'AYAOuFRuST2Z03icMtJLCz',
    appSecret: 'VXQGJRRDVJGWLIKEDLAF3MVRSI'
  },
  google:{
    apiKey: 'AIzaSyBm1WUQ1ezDF9X51yw1p1odlV3dsxYNN30'
  }
};

export default config;
export const {
  router,
  auth0,
  firebase,
  elastic,
  filestack,
  google,
  search
} = config;
